"use strict";

var _taggedTemplateLiteral = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Orb = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var css_1 = require("@emotion/css");

var DEFAULT_ORB_BACKGROUND_GRADIENT = "radial-gradient(\n  75.29% 75.29% at 64.96% 24.36%,\n  #dcc8d0 15.62%,\n  #78c8cf 30.21%,\n  #4d959e 42.71%,\n  #305eb9 55.73%,\n  #311f12 79.69%,\n  #684232 90.62%,\n  #2d1c13 100%\n);";

var Orb = function Orb(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '100%' : _ref$size;
  return jsx_runtime_1.jsx("div", {
    className: css_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        display: block;\n        height: ", ";\n        width: ", ";\n        background: ", ";\n        border-radius: 1500px;\n      "])), size, size, DEFAULT_ORB_BACKGROUND_GRADIENT)
  }, void 0);
};

exports.Orb = Orb;